import apiClient from '../client';
import type { AssetsResponse, AssetsSearchParams, QuoteCurrenciesResponse } from '../types';

export const assetsAPI = {
  /**
   * Search assets with pagination
   */
  search: async (params: AssetsSearchParams = {}): Promise<AssetsResponse> => {
    const response = await apiClient.get<AssetsResponse>('/assets', {
      params: {
        page: params.page || 1,
        perPage: params.perPage || 20,
        search: params.search || undefined,
      },
    });
    return response.data;
  },

  /**
   * Get all available quote currencies (EUR, TRY, USDT)
   */
  getQuoteCurrencies: async (): Promise<QuoteCurrenciesResponse> => {
    const response = await apiClient.get<QuoteCurrenciesResponse>('/assets/get-all-quote-currency');
    return response.data;
  },

  /**
   * Get home screen symbol data (public endpoint)
   */
  getHomeSymbol: async (): Promise<AssetsResponse> => {
    const response = await apiClient.get<AssetsResponse>('/assets/get-home-symbol-data');
    return response.data;
  },
};
